<div class="w-100 float-left">
    <div class="w-100 float-left v-align relative b-b">
        <h5 class="medium float-left">{{'manageTenant' | translate}}</h5>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-primary float-right mb-2" (click)="newTenant()"> {{'addTenant' | translate}}</button>
    </div>

    <!-- EMPLOYEE DETAILS GRID -->
    <div class="w-100 float-left mt-3">
        <div class="light-bg w-100 float-left p-2 grid-details">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 medium"> {{'mobAppName' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 medium">{{'tenantName' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 medium"> {{'timeZone' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 medium"> {{'status' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center">
                <h6 class="mb-lg-0 medium"> {{'action' | translate}} </h6>
            </div>
        </div>
        <div class="w-100 float-left p-md-2 grid-details" *ngFor="let tenant of tenantData;index as i">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 text-truncate" *ngIf="tenant.appName != null"> {{tenant.appName}} </h6>
                <h6 class="mb-lg-0 text-truncate" *ngIf="tenant.appName == null"> {{'notAvailable' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 text-truncate"> {{tenant.orgName}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 text-truncate" *ngIf="tenant.timeZone != null"> {{tenant.timeZone}} </h6>
                <h6 class="mb-lg-0 text-truncate" *ngIf="tenant.timeZone == null"> {{'notAvailable' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 text-truncate" *ngIf="tenant.status != null"> {{tenant.status}} </h6>
                <h6 class="mb-lg-0 text-truncate" *ngIf="tenant.status == null"> {{'notAvailable' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center relative">
                <h6 class="mb-lg-0" (click)="tableActions(i)" ngbTooltip="{{'clickForMoreOption' | translate}}">
                    <i class="fa fa-ellipsis-h"></i>
                </h6>
                <div class="empActions m-t-nsmd" style="right:75px !important" *ngIf="i == trackHides">
                    <i class="fa fa-caret-up caret-up"></i>
                    <ul class="m-0 p-0">
                        <li (click)="editTenant(tenant.id)">{{'edit' | translate}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- PAGINATION -->
        <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
            <h6 class="float-left mb-0"> {{startingPage}} - {{endingPage}} {{'itemsOf'}} {{collectionSize}} </h6>
            <div class="float-left ml-2 align-v-center">
                <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
                <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                        (change)="OnPageSizeChanged($event.target.value)">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                </select>
            </div>
            <div style="flex-grow: 1;"></div>
            <ngb-pagination [collectionSize]="collectionSize" [rotate]="true" [pageSize]="pageSize" [maxSize]="5"
                            [ellipses]="false"
                            [(page)]="page" [boundaryLinks]="true" (pageChange)="onPageChange($event)"
                            class="float-right"></ngb-pagination>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/superAdmin/tenantManagement.html